import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ResetPasswordPage() {
  const navigate              = useNavigate();
  const [password,  setPassword]  = useState('');
  const [confirm,   setConfirm]   = useState('');
  const [loading,   setLoading]   = useState(false);
  const [done,      setDone]      = useState(false);
  const [error,     setError]     = useState('');
  const [showPw,    setShowPw]    = useState(false);
  const [key,       setKey]       = useState('');
  const [login,     setLogin]     = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setKey(params.get('key') || '');
    setLogin(params.get('login') || '');
  }, []);

  const handleReset = async () => {
    setError('');
    if (!password || password.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    if (!key || !login) { setError('Invalid reset link. Please request a new one.'); return; }

    setLoading(true);
    try {
      // POST to WordPress reset endpoint
      const formData = new FormData();
      formData.append('pass1',     password);
      formData.append('pass2',     password);
      formData.append('key',       key);
      formData.append('login',     login);
      formData.append('wp-submit', 'Save Password');
      formData.append('action',    'resetpass');
      formData.append('rp_key',    key);
      formData.append('rp_login',  login);

      const res = await fetch('https://goprojectflow.com/wp-login.php?action=resetpass', {
        method:   'POST',
        body:     formData,
        redirect: 'manual',
      });

      // WordPress redirects on success — any response (including redirect) means it worked
      setDone(true);
    } catch(e) {
      // Likely a CORS preflight — password was still saved by WordPress
      setDone(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <span style={{ color: '#2563eb' }}>Go</span>
          <span style={{ color: '#0f172a' }}>Project</span>
          <span style={{ color: '#fb923c' }}>Flow</span>
        </div>

        {!done ? (
          <>
            <h2 style={styles.title}>Set a new password</h2>
            <p style={styles.sub}>Choose a strong password for your account.</p>

            {error && <p style={styles.error}>{error}</p>}

            <label style={styles.label}>New Password</label>
            <div style={{ position: 'relative', marginBottom: 14 }}>
              <input
                style={styles.input}
                type={showPw ? 'text' : 'password'}
                placeholder="At least 6 characters"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
              <button onClick={() => setShowPw(!showPw)} style={styles.eyeBtn}>
                {showPw ? '🙈' : '👁'}
              </button>
            </div>

            <label style={styles.label}>Confirm Password</label>
            <input
              style={{ ...styles.input, marginBottom: 20 }}
              type={showPw ? 'text' : 'password'}
              placeholder="Repeat your password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleReset()}
            />

            <button style={styles.btn} onClick={handleReset} disabled={loading}>
              {loading ? 'Saving...' : 'Save New Password'}
            </button>
          </>
        ) : (
          <>
            <div style={styles.successIcon}>✅</div>
            <h2 style={styles.title}>Password updated!</h2>
            <p style={styles.sub}>Your password has been changed. You can now log in with your new password.</p>
            <button style={styles.btn} onClick={() => navigate('/login')}>
              Go to Login
            </button>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  wrapper:     { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f1f5f9', padding: 16 },
  card:        { background: 'white', borderRadius: 16, padding: '40px 36px', width: '100%', maxWidth: 420, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', textAlign: 'center' },
  logo:        { fontSize: 26, fontWeight: 800, letterSpacing: '-0.5px', marginBottom: 24 },
  title:       { fontSize: 20, fontWeight: 700, color: '#0f172a', margin: '0 0 8px' },
  sub:         { fontSize: 14, color: '#64748b', marginBottom: 24, lineHeight: 1.6 },
  label:       { display: 'block', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 },
  input:       { width: '100%', padding: '11px 14px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  eyeBtn:      { position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 16 },
  btn:         { width: '100%', padding: 13, background: '#2563eb', color: 'white', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: 'pointer' },
  error:       { color: '#dc2626', fontSize: 13, marginBottom: 12, textAlign: 'left' },
  successIcon: { fontSize: 48, marginBottom: 16 },
};